/**
 * 편성요구/조정 상태바 등 inline style용 색 (hex 직접 기입 금지)
 */
import { theme } from 'styles/theme';

export const uiColor = {
  primary: theme.colors.primary,
  warning: theme.colors.status.warningStrong,
  success: theme.colors.status.successStrong,
  danger: theme.colors.status.dangerText,
  secondary: theme.colors.text.secondary,
};
